<template>
  <b-modal
    id="depositRequestHistoryModal"
    title="충전요청내역"
    size="lg"
    hide-footer
    @shown="onShown"
  >
    <div class="table_list">
      <table class="list text-sm">
        <colgroup>
          <col width="50" />
          <col width="150" />
          <col width="120" />
          <col width="100" />
          <col width="220" />
          <col width="150" />
        </colgroup>
        <thead>
          <tr>
            <th>No</th>
            <th>요청일시</th>
            <th>요청금액</th>
            <th>입금은행</th>
            <th>입금계좌</th>
            <th>입금기한</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="requestList.length === 0">
            <td colspan="5"><span>요청중인 충전 내역이 없습니다.</span></td>
          </tr>
          <tr v-for="(item, index) in requestList" :key="index">
            <td><span>{{ requestList.length - index }}</span></td>
            <td><span>{{ item.reg_dt }}</span></td>
            <td><span>{{ fn_comma_won(item.request_amt) }} 원</span></td>
            <td><span>{{ item.virtual_bank_nm }}</span></td>
            <td><span>{{ item.virtual_account_no }}</span></td>
            <td><span>{{ formatDueDate(item.due_date) }}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios'
import commonUtil from '@/mixin/commonUtil'

export default {
  name: 'depositRequestHistoryModal',
  mixins: [commonUtil],
  props: {
    clinicDoctorId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      requestList: [],
    }
  },
  methods: {
    onShown() {
      axios
        .post('/api/user/mypage/getDepositRequestList', {
          clinic_doctor_id: this.clinicDoctorId,
        })
        .then((res) => {
          this.requestList = res.data.depositRequestList || []
        })
        .catch((err) => console.log(err))
    },
    formatDueDate(dueDate) {
      if (!dueDate) return ''
      const d = new Date(dueDate)
      if (isNaN(d)) return dueDate
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
  },
}
</script>